<template>
<div class="trend-related-chart-group-wrapper">
  <trend-related-chart-v2
    v-for="data in dataList"
    v-if="data.dimensions.length > 0"
    :key="data.id"
    :data-config="data"
    :unit-prop="unitProp"
    :chart-height="chartHeight"
    :download-name="downloadName"
    :related-chart-width="relatedChartWidth"
    :click-able="showList"
    :scale="scale"
    :options="options"
    :data-list="dataList"
    :is-more="isMore"
    v-bind="$attrs"
    :filter-site-map="filterSiteMap"
    :filter-factor-map="filterFactorMap"
  />

  <div v-if="clickData" class="click-data-table-wrapper">
    <div class="click-data-table-header">
      <span class="click-data-table-title">{{clickData.name}}</span>
      <div class="click-data-table-btn" @click="clickData = null">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <section class="click-data-table-body">
      <data-table
        ref="dataTable"
        :columns="tableColumns"
        :data="clickData.dataList"
        :highlight-data-time="clickData.dataTime"
        selected-style
      />
    </section>
  </div>
</div>
</template>

<script>
import XYChart from '../DataChart/XYChart'
import TrendRelatedChartV2 from './TrendRelatedChartV2'
import DataTable from './DataTable'

export default {
  name: 'TrendRelatedChartWrapperV2',
  components: {TrendRelatedChartV2, XYChart, DataTable},
  props: {
    dataList: {
      required: true,
      type: Array
    },
    unitProp: {
      required: true,
      type: String
    },
    chartHeight: {
      type: String,
      default: 'auto'
    },
    downloadName: {
      required: true,
      type: String
    },
    relatedChartWidth: {
      type: String,
      default: '418px'
    },
    factors: {
      required: true,
      type: Array
    },
    showList: {
      type: Boolean
    },
    scale: {
      type: Boolean,
      default: false
    },
    filterSiteMap: {
      required: true,
      type: Object
    },
    filterFactorMap: {
      required: true,
      type: Object
    },
    siteDevice: {
      required: true,
      type: Array
    },
    isMore: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    clickData: null,
    options: []
  }),
  computed: {
    tableColumns () {
      let id = this.clickData.id
      let dataConfig = this.dataList.find(dataConfig => dataConfig.id === id)

      if (!dataConfig) {
        return []
      }

      let {unitProp} = this

      return dataConfig.dimensions.reduce((list, dimension) => {
        let unit = dimension[unitProp]

        list.push({
          id: dimension.id,
          name: `${dimension.name}${unit ? `(${unit})` : ''}`,
          width: 200,
          align: 'left'
        })

        return list
      }, [{
        id: 'dataTime',
        name: '时间',
        width: 150,
        align: 'left'
      }])
    }
  },
  methods: {
    onRelatedChartDblclick (clickData) {
      this.clickData = Object.freeze(clickData)
      this.$nextTick(() => {
        this.$refs.dataTable.doLayout()
      })
    },
    setOption () {
      let {filterSiteMap, siteDevice} = this
      let options = siteDevice.reduce((map, el) => {
        if (!map[el[0]]) {
          map[el[0]] = {
            ...filterSiteMap[el[0]]
          }
        }

        return map
      }, {})

      this.options = Object.freeze(Object.values(options))
    }
  },
  watch: {
    dataList (data) {
      this.clickData = null
    },
    isMore (data) {
      if (data) {
        this.setOption()
      }
    },
    filterSiteMap () {},
    filterFactorMap () {},
    siteDevice (siteDevice) {
      if (siteDevice.length > 0) {
        this.setOption()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.trend-related-chart-group-wrapper {
  display: flex;
  flex-direction: column;
  gap: 22px;
  width: 100%;
  height: 100%;
  overflow: auto;

  .click-data-table-wrapper {
    position: absolute;
    right: 20px;
    bottom: 20px;
    left: 20px;
    background-color: #ffffff;

    > .click-data-table-header {
      position: relative;
      height: 30px;
      background: linear-gradient(to right, #fbc15a 0%, #fff 100%);

      > .click-data-table-title {
        line-height: 30px;
        padding-left: 10px;
        color: #ffffff;
      }

      > .click-data-table-btn {
        position: absolute;
        font-size: 20px;
        top: 0;
        right: 10px;
        bottom: 0;
        width: 1em;
        height: 1em;
        line-height: 1;
        margin: auto 0;
        color: rgba(153, 153, 153, .7);
        cursor: pointer;

        &:hover {
          color: rgba(153, 153, 153, 1);
        }
      }
    }

    > .click-data-table-body {
      width: 100%;
      height: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Data/TrendRelatedChartWrapperV2.vue